import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';

import Axios from 'axios'
import { URL } from '../../api';

import { api } from '../../api';
import Swal from 'sweetalert2'

export default class Timeend extends Component {
    

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,
                roomtime:'',
            };
           this.gettime = this.gettime.bind(this);
          }

          componentDidMount (){
            if (localStorage.getItem('name') == null ) {
                window.location.href = 'https://lookmaenamping.com/sorlalum'
            } else {
  
            }
              this.gettime();
          }

          gettime (){
            this.setState({ loading:true})
          
              api.get('lkselectroomidtimeend.php?roomid='+this.props.id_room)
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
              if (res.data.length !== 0) {
                 this.setState({ roomtime: res.data[0].timeend })
              }
               
              }) 
          }


       
            update = () => {
                this.setState({
                    name: "",
                    lname: ""
                })
            }


    render() {


        var startDate = new Date;
        var endDate   = new Date(this.state.roomtime);
        var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
      
        //Calculate time
        var days = Math.floor(seconds / (3600*24));
        var hrs_d   = Math.floor((seconds - (days * (3600*24))) / 3600);
        var hrs   = Math.floor(seconds / 3600);
        var mnts = Math.floor((seconds - (hrs * 3600)) / 60);
        var secs = seconds - (hrs * 3600) - (mnts * 60);
      
        //Add 0 if one digit
        if(hrs_d<10) hrs_d = "0" + hrs_d;
        if(mnts<10) mnts = "0" + mnts;
        if(secs<10) secs = "0" + secs;
     const  dds  = days ;
     const  sce1  = hrs_d + ':' + mnts + ':' + secs;
     const  sce  = sce1.substring(0, 8);
    
     console.log(dds);
      
        return (
       
                 <>
                   <span>เหลือ {dds} วัน  {sce} ชั่วโมง</span> 
                 </>
                   
     
        )
    }
}
